import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { GtmGenericDialogsService, GtmImportPack, provideGtmGenericDialogsService } from '@partners/gtm';
import {
  DialogContainerComponent,
  DialogIconDirective,
  DialogImportPack,
  FilledButtonComponent,
  IAlertConfig,
  IconComponent
} from '@partners/ui';
import { AlertIconComponent } from '../../components';

/**
 * @description
 * a default alert dialog ui, contained within a dialog-container component. the container provides
 * a consistent dialog template structure with the following template slots: icon, title, body, footer
 * as well as close button, it also provides centralized access to basic common dialog behavior such
 * as dismiss function, dialog button behaviors, dialog animations etc'
 */

@Component({
  standalone: true,
  providers: [provideGtmGenericDialogsService()],
  imports: [FilledButtonComponent, DialogImportPack, IconComponent, AlertIconComponent, GtmImportPack],
  template: `
    <dialog-container #container gtmFunnelStepEvent="funnelStepEvent">
      <ng-template dialogIcon>

        @if(dialogContainer.iconName()){
          <icon data-alt="אייקון אילוסטרציה שגיאה" iconVariant="rounded" iconSize="lg" [iconName]="dialogContainer.iconName()" />
        }
        @else {
        <alert-icon data-alt="אייקון אילוסטרציה שגיאה" />
        }

      </ng-template>

      <ng-template dialogTitle let-context>
        <span>{{ context.title }}</span>
      </ng-template>
      <ng-template dialogBody let-context>
        <span>{{ context.message }}</span>
      </ng-template>
      <ng-template dialogFooter let-context>
        <div class="dialog-action">
          <filled-button (click)="dismissAlert()" gtmClickEvent="okClickEvent" class="primary-action-button">{{ context.buttons.ok }}</filled-button>
        </div>
      </ng-template>
    </dialog-container>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'alert-dialog'
  }
})
export class AlertComponent implements OnInit {
  private readonly _gtmService = inject(GtmGenericDialogsService);

  @ViewChild('container', { static: true, read: DialogContainerComponent })
  dialogContainer: DialogContainerComponent;

  @ViewChild('dialogIcon', { static: true, read: DialogIconDirective })
  iconTemplate: DialogIconDirective;

  ngOnInit() {
    this.setGtmDialogConfig();
  }

  setGtmDialogConfig() {
    const dialogConfig = this.dialogContainer.dialogConfig as IAlertConfig;

    const gtmDialogConfig = {
      message: dialogConfig.message || dialogConfig.title,

      buttons: {
        ok: dialogConfig.buttons?.ok
      }
    };

    this._gtmService.setDialogConfig(gtmDialogConfig);
  }

  dismissAlert() {
    this.dialogContainer.dismissDialog(undefined);
  }
}
